import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Locations',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M12 18s6-4.91 6-9.71C18 4.74 15.36 2 12 2S6 4.74 6 8.29c0 4.8 6 9.71 6 9.71zM10 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm14 10.5c0 2.3-6.04 3.5-12 3.5S0 20.8 0 18.5c0-1.61 2.95-2.67 6.76-3.17.24.32.47.63.71.92C3.42 16.71 1 17.73 1 18.5 1 19.52 5.29 21 12 21s11-1.48 11-2.5c0-.77-2.42-1.79-6.47-2.26.24-.29.48-.6.71-.92 3.81.51 6.76 1.57 6.76 3.18z" }
      })]
    );
  }
};